<template>
        
    <div class="row">
        <!-- Left Side -->
        <div class="col-12 col-sm-5 col-md-5 col-lg-5">
            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span> Patient: </span>
                </div>
                <div class="col-md-7">
                  {{patient && patient.patient ? patient.patient.full_name : ""}}
                </div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span> Patient ID: </span>
                </div>

                <div class="col-md-7">
                    <span> <strong>{{ patientId }}</strong> </span>
                </div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span> Patient Phone No: </span>      
                </div>

                <div class="col-md-7">
                    <span> <strong> {{patientMobile}} </strong> </span>
                </div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span> Select Admission info: </span>      
                </div>

                <div class="col-md-7">
                    {{patient ? patient.admission_no : ""}}
                </div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span> Ward / Bed / Cabin: </span>      
                </div>

                <div class="col-md-7">
                    <span> <strong>
                        {{ patient && patient.service_resource ? patient.service_resource.name : "" }}
                    </strong> </span>
                </div>
            </div>

            <div class="row">
                <div class="col-md-5 d-flex align-items-center">
                    <span> Referred Doctor: </span>
                </div>

                <div class="col-md-7">
                  <span> <strong> {{patient && patient.human_resource ? patient.human_resource.name : ""}} </strong> </span>
                </div>
            </div>

            <div v-if="patient && patient.consultant" class="row">
                <div class="col-md-5 d-flex align-items-center">
                    <span> Consultant: </span>
                </div>

                <div class="col-md-7">
                  <span> <strong> {{patient.consultant.name}} </strong> </span>
                </div>
            </div>

        </div>
        <div class="col-md-2"></div>
        <!-- Right Side -->
        <div class="col-12 col-sm-5 col-md-5 col-lg-5">

          <div class="row h-40" v-if="isReturn">
            <div class="col-md-5 d-flex align-items-center">
              <span> Invoice Date: </span>
            </div>

            <div class="col-md-7">
              {{formData.invoice_date}}
            </div>
          </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span v-if="isReturn"> Return Date: </span>
                    <span v-else> Invoice Date: </span>
                </div>

                <div class="col-md-7">
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="date"
                        placeholder=""
                        v-model="formData.date"
                    >
                </div>
            </div>

            <div class="row h-40 mt-2">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Select Referrer: </span>
                </div>

                <div class="col-md-7"> 
                    <AsyncSelect
                        placeholder="Select Referrer"
                        v-model="formData.referrer_id"
                        :api-service="fetchContactProfiles"
                        :additional-query="{ type: 'agent' }"
                        :format-label="formatPatientLabel"
                        :reduce="referrer => referrer.id"
                        :additionalOption="additionalOption"
                    />
                </div>
            </div>

        </div>

        <div class="mt-2 col-md-5">
            <AsyncSelect
                placeholder="Select Product"
                v-model="productId"
                :api-service="fetchProductList"
                :reduce="name => name.id"
                :format-label="option => option.text"
                :additional-query="additionalProductQuery"
                label="text"
                :disabled="isReturn"
            />
        </div>

    </div>

</template>

<script setup>
import {computed, inject, onMounted, reactive, ref, watch} from 'vue'
import {useStore} from 'vuex';
import {useRoute, useRouter} from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleInventory from "@/services/modules/inventory";
import handleContact from '@/services/modules/contact'
import { cloneDeep } from 'lodash';

const { fetchSalesOrderById } = handlePurchase();

const props = defineProps({
  addNewItem: {
    type: Function
  },
  products: {
    type: Array,
    default: []
  },
  tableItems: {
    type: Array
  },
  patient: {
    type: Object
  },
  referrer: {
    type: Object || null,
    default: null
  },
  isReturn: {
    type: Boolean,
    default: false
  },
  from: {
    type: String,
    default: ''
  }
})

const $route = useRoute();
const companyId = $route.params.companyId
const formData = inject('formData');
const showError = inject('showError')
const productId = ref(null);
const additionalProductQuery = {
    product_type: "services"
}
const additionalOption = ref([]);
const salesOrder = ref(null);

const {fetchProductList} = handlePurchase();
const {getProduct} = handleInventory();
const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();

//computed
const patientMobile = computed(() => {
    if ( props.patient && props.patient.patient ) {
        return props.patient.patient.mobile_no
    }
    return null
})

const patientId = computed(() => {
    if ( props.patient && props.patient.patient ) {
        return props.patient.patient.serial_no
    }
    return null
})

onMounted(() => {
    formData.value.date =  new Date().toISOString().split('T')[0];
    if (props.referrer) {
        additionalOption.value.push(props.referrer);
    }
})

watch(productId, async () => {
    const found = !!props.tableItems.find(item => item.product_id === productId.value);

    if (found) {
        showError('Item already selected!');
        return;
    }
    
    const productResp = await getProduct({
        id: productId.value,
        company_id: companyId
    })
    if (!productResp.data) {
        showError("Something went wrong please try again");
        return;
    }
    let selected = productResp.data;
    let product = {
        name: selected.name
    }
    props.tableItems.push({
        product_id: productId.value,
        name: selected.name,
        description: selected.description.unit.description,
        quantity: 1,
        rate: selected.description.sales_price,
        discount: 0,
        vat: selected.description.vat_rate,
        sub_total: 0,
        discount_amount: 0,
        discount_percent: 0,
        vat_amount: 0,
        total: 0,
        is_edit: false,
        product: product,
        dentition_pertains: []
    })
})


const getSalesOrder = async () => {
    
    const salesOrderId = $route.query.order_master_id;

    if(!salesOrderId || $route.name !== 'dental-service') return;

    await fetchSalesOrderById(salesOrderId, `?company_id=${companyId}`).then(res => {
        if(res.data) {
            salesOrder.value = res.data;
            setSalesOrderProducts();
        }
    });
}

const setSalesOrderProducts = () => {
    for(const item of salesOrder.value.general) {

        const product = cloneDeep(item.product);

        let serviceResource = null;

        if(item.contact_profile_id) {
            serviceResource = {
                id: item.contact_profile_id,
                name: item.contact_profile_name,
                full_name: item.contact_profile_name
            }
        }

        const tableItem = {
            product_id: item.product_id,
            name: product.name,
            description: product.description && product.description.unit && product.description.unit.description ? product.description.unit.description : '',
            quantity: item.quantity,
            rate: item.rate,
            discount: item.discount,
            vat: item.vat,
            sub_total: item.amount,
            discount_amount: item.discount_amount,
            discount_percent: item.discount_percent,
            vat_amount: item.vat_amount,
            total: item.total_amount,
            is_edit: false,
            product: product,
            service_resource: serviceResource,
            dentition_pertains: item.dentition_pertains   || []
        };

        if (props.from === 'add' || item.invoice_qty < 1) {
            tableItem.dentition_pertains.forEach(pertain => {
                pertain.is_billed = true;
            });
        }

        props.tableItems.push(tableItem);
    }
}

onMounted(() => {
    getSalesOrder();
})

</script>

<style>
.select label{
    font-size: 14px;
}
.h-40{
    height: 40px;
    align-items: center;
}
</style>